export const apiUrl = "https://umnayavorona.ru:8443/api/v1/";
export const url = "https://umnayavorona.ru:8443/";

export const URL_CONFIG = {
    URL: "https://umnayavorona.ru",
    API_VERSION: "v1",
    AUTH_PORT: 8543,
    API_PORT: 8443,
};
